import { render, staticRenderFns } from "./ModalPayPeriodNew.vue?vue&type=template&id=27aef5b0&"
import script from "./ModalPayPeriodNew.vue?vue&type=script&lang=js&"
export * from "./ModalPayPeriodNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports